require('./angular-animate');
module.exports = 'ngAnimate';



//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-animate/index.js
// module id = mWUN
// module chunks = 0